import { ref, computed } from 'vue';
import {
    listCategories,
    createCategory,
    updateCategory,
    deleteCategory,
    clearCategories,
    sortCategoriesList,
} from '@/api/categories';
import {useRoute} from "vue-router";
import {sortAccountList} from "@/api/accounts";


export function useCategories() {
    const route = useRoute();
    const categories = ref([]);
    const loading = ref(false);
    
    const isSuccess = ref(false);
    const messageSuccess = ref('');
    const messageError = ref('');
    
    const page = ref( Number(route.query.page ?? 1) );
    const size = ref( Number(route.query.size ?? 3) );
    const totalPages = ref( Number(0) );
    const totalElements = ref( Number(0) );
    
    function setSuccess(msg) {
        messageSuccess.value = msg;
        isSuccess.value = true;
    }
    
    function setError(msg) {
        messageError.value = msg;
        isSuccess.value = false;
    }
    
    async function load(pageArg = 1, sizeArg = 20) {
        loading.value = true;
        try {
            const data = await listCategories(pageArg, sizeArg);
            page.value = data.number + 1;
            size.value = data.size;
            totalPages.value = data.totalPages;
            totalElements.value = data.totalElements;
            categories.value = data.content;
        } catch (e) {
            setError('Не удалось загрузить');
        } finally {
            loading.value = false;
        }
    }
    
    async function addCategory(payload) {
        try {
            await createCategory(payload);
            setSuccess('Категория добавлена');
            await load();
        } catch (e) {
            
            setError('Не удалось добавить категорию');
        }
    }
    
    async function updateCategoryById(id, payload) {
        try {
            await updateCategory(id, payload);
            setSuccess('Категория обновлена');
            await load();
        } catch (e) {
            
            setError('Не удалось обновить категорию');
        }
    }
    
    async function deleteCategoryById(id) {
        try {
            await deleteCategory(id);
            setSuccess('Категория удалена');
            await load();
        } catch (e) {
            
            setError('Не удалось удалить категорию');
        }
    }
    
    async function clearAll() {
        try {
            await clearCategories();
            setSuccess('Все категории удалены');
            await load();
        } catch (e) {
            
            setError('Не удалось очистить категории');
        }
    }
    
    async function sortCategories(payload) {
        try {
            await sortCategoriesList(payload);
            setSuccess('Сортировка обновлена');
        } catch (e) {
            
            setError('Не удалось обновить сортировку');
        }
    }
    
    return {
        categories,
        loading,
        isSuccess,
        messageError,
        messageSuccess,
        page,
        size,
        totalPages,
        totalElements,
        load,
        addCategory,
        updateCategoryById,
        deleteCategoryById,
        clearAll,
        sortCategories,
    };
}
